import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { projectsEndpointIds } from 'root/src/shared/projects/projects.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
export const searchProjectsEndpoint = {
    [projectsEndpointIds.SEARCH_PROJECTS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        payloadSchema: {
            type: 'object',
            properties: {
                filter: {
                    type: 'object',
                    properties: {
                        value: {
                            type: 'string',
                        },
                    },
                },
                page: {
                    type: 'number',
                },
                limit: {
                    type: 'number',
                },
                select: {
                    type: 'array',
                    items: {
                        type: 'string',
                    },
                },
            },
        },
        endpointType: otherEndpointType,
    },
};
